import styles from './LPFooter.module.scss'

interface ServiceLink {
  href: string
  title: string
}

interface CategoryLink {
  href: string
  title: string
}

const serviceLinks: ServiceLink[] = [
  {
    href: '/services/servicedesign',
    title: 'サービスデザイン',
  },
  {
    href: '/services/mobileapp',
    title: 'モバイルアプリ',
  },
  {
    href: '/services/cloudservice',
    title: 'クラウド活用サービス',
  },
  {
    href: '/services/designsprint',
    title: 'デザインスプリント',
  },
  {
    href: '/services/frontend',
    title: 'フロントエンド',
  },
  {
    href: '/services/growthhack',
    title: 'サイト改善ソリューション',
  },
  {
    href: '/services/uiuxdesign',
    title: 'UX/UIデザイン',
  },
  {
    href: '/services/webapp',
    title: 'ウェブアプリ',
  },
  {
    href: '/services/appgrowth',
    title: 'プロダクトグロース・UX改善支援',
  },
  {
    href: '/services/od',
    title: '組織開発・イノベーション',
  },
]

const categoryLinks: CategoryLink[] = [
  {
    href: '/case',
    title: 'Case',
  },
  {
    href: '/about',
    title: 'About',
  },
  {
    href: '/topics/all/page/1',
    title: 'Topics',
  },
  {
    href: '/recruit',
    title: 'Recruit',
  },
]

const servicesList = serviceLinks.map(
  ({ title, href }): JSX.Element => (
    <li key={title} className={styles.li}>
      <a href={href} target="_blank" rel="noopener" className={styles.serviceLink}>
        {title}
      </a>
    </li>
  ),
)

const categoryList = categoryLinks.map(
  ({ title, href }): JSX.Element => (
    <a key={title} href={href} target="_blank" rel="noopener" className={styles.categoryLink}>
      {title}
    </a>
  ),
)

const LPFooter: React.FC = () => {
  return (
    <>
      <section className={styles.LPFooter}>
        <div className={styles.footer}>
          <div className={styles.address_group}>
            <img src="/img/common/logo_aitria.svg" className={styles.aitriaLogo} alt="Aitria" />
            <p className={styles.address}>〒107-0052</p>
            <p className={styles.address}>東京都港区赤坂八丁目１番22号 NMF青山一丁目ビル３階</p>
            <div className={styles.button}>
              <a
                href="https://www.google.co.jp/maps/place/Aitria+Co.,+Ltd./@35.673452,139.727701,17z/data=!3m2!4b1!5s0x60188b5ee42ea6b7:0xf9440bc4b8f6a3d5!4m6!3m5!1s0x60188ca66b638993:0x422d4622e50c7d!8m2!3d35.673452!4d139.727701!16s%2Fg%2F1hc134bxp?hl=ja&entry=ttu"
                rel="noopener noreferrer"
                target="_blank"
                className={styles.toGoogleMap}
              >
                <img className={styles.pin} src="/images/lp2/GoogleMapPin.svg" alt="GoogleMap" />
                Google Map
              </a>
            </div>
          </div>
          <div className={`${styles.link_group}`}>
            <a href="/service/" target="_blank" rel="noopener">
              <span className={`${styles.categoryLink} ${styles.title}`}>Services</span>
            </a>
            <div className={styles.link_wrapper}>
              <ul className={styles.ul}>{servicesList}</ul>
            </div>
            <div className={styles.normal_text}>{categoryList}</div>
          </div>
        </div>
        <div className={styles.privacyCopylink}>
          <a className={styles.privacyPolicy} href="/privacy" target="_blank" rel="noopener">
            プライバシーポリシー
          </a>
          <p className={styles.copyright}>© Aitria Co., Ltd.</p>
        </div>
      </section>
    </>
  )
}

export default LPFooter
